import { styled } from 'styled-components';

import { RichTextHeadline } from '#/components/Text/RichTextHeadline';
import { cssBreakpoints, gutterWidth } from '#/theme/theme';

export const CmsThreeStepCtaBlockHeadlineRichText = styled(RichTextHeadline)`
  p {
    line-height: 1.25;
    font-weight: inherit !important;
    margin: 0;
  }
`;

export const CmsThreeStepCtaBlockHeadlineContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75em;
  width: 100%;
  margin-bottom: 24px;
`;

export const CmsThreeStepCtaBlock_Box_1 = styled.div`
  align-items: center;
  flex-direction: column;
  width: 100%;
  display: flex;
  justify-content: center;

  @media all and (min-width: ${cssBreakpoints.mdUp}) {
    align-items: stretch;
    flex-direction: row;
    margin-inline: ${-gutterWidth / 2}px;
    width: calc(100% + ${gutterWidth}px);
  }
`;

export const CmsThreeStepCtaBlock_Box_2 = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  flex-direction: column;
  justify-content: center;

  &[data-overlap] {
    @media all and (min-width: ${cssBreakpoints.xsUp}) {
      margin-top: -90px;
    }

    @media all and (min-width: ${cssBreakpoints.smUp}) {
      margin-top: -120px;
    }

    @media all and (min-width: ${cssBreakpoints.mdUp}) {
      margin-top: -110px;
    }
  }
`;
